import styled from "styled-components";
import { TextArea } from "notes";
import { FieldMessage } from "Components";

export const TextAreaField = ({
  onChange,
  value,
  field,
  error = {},
  ...props
}) => {
  const handleText = (value) => {
    onChange({ [field.name]: value });
  };

  return (
    <>
      <StyledTextArea
        onChange={(e) => handleText(e.target.value)}
        value={value}
        placeholder={field.placeholder}
        error={!!error.status}
        {...props}
      />
      <FieldMessage active={!!error.status} content={error.message} />
    </>
  );
};

const StyledTextArea = styled(TextArea)`
  font-size: 16px;
`;
